import React, { Suspense } from 'react'
import styled from 'styled-components';
import { colors } from '../../Assets/styles/colors';
import { ReactComponent as GenericAvatar } from '../../Assets/iconsv2/generic/GenericAvatar.svg'
import { useTranslate } from '@tolgee/react';
import { ReactComponent as CheckEmpty } from "../../Assets/iconsv2/generic/checkEmpty.svg"
import { ReactComponent as Check } from "../../Assets/iconsv2/generic/check.svg"



const ForwardModalContactElement = ({ item, selected, handleSelectContact, invite, handleInvite, noCheck }) => {

  const handleClick = (item) => {
    handleSelectContact(item)
  }
  const { t } = useTranslate();
  return (

    <Warpper onClick={() => handleClick(item)} >
      <FoundContact  >
        <FoundContactAvatar>
          {item.profile_picture ? <img src={item.profile_picture} alt='avatar' /> : <GenericAvatar />}
        </FoundContactAvatar>
        <p>{item.name}</p>

        {invite ?
          <InviteButton >
            {t('general.invite')}
          </InviteButton>
          :
          !noCheck &&
          <CheckWrapper>
            {selected ? <CheckedWrapper>
              <Check />
            </CheckedWrapper> :
              <CheckEmptyWrapper>
                <CheckEmpty />
              </CheckEmptyWrapper>}
          </CheckWrapper>

        }

      </FoundContact>
    </Warpper>

  )
}

export default ForwardModalContactElement
const Warpper = styled.div`
display:block;
z-index:1;
`
const FoundContact = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor:pointer;
  
  p {
     color:  ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
  }
`;

const FoundContactAvatar = styled.div`
  display: flex;
  height:35px;
  width:35px;
  max-width: 35px;
  min-height: 35px;
  min-width: 35px;
  max-height: 35px;
  border-radius: 100%;
  position:relative;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius:100%;
  }

  svg{
    object-fit: cover;
   width: 100%;
   height: 100%;
 }
`;


const InviteButton = styled.button`
border:none;
background:none;
font-size: 16px;
font-weight: 400;
line-height: 22px;
color:${colors.purple};
cursor:pointer;
`

const CheckWrapper = styled.div`
display:flex;
margin-left:auto;
align-items:center;
svg{
fill:transparent;
fill:color;
}
`
const CheckedWrapper = styled.div`
display:flex;

svg{
color:${({ theme }) => theme.check.background};
fill:${({ theme }) => theme.check.checkSign};
}
`
const CheckEmptyWrapper = styled.div`
display:flex;
svg{
color:${({ theme }) => theme.check.border};
stroke:${({ theme }) => theme.check.checkSign};
}
`